import {
  Accordion as MuiAccordion,
  AccordionDetails as MuiAccordionDetails,
  AccordionSummary as MuiAccordionSummary,
  Box,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Table,
} from '@mui/material';
import { type BackupJob, type RestoreJob } from '@repo/api-gw-sdk';

import { useDAL } from '@/contexts/useDAL';
import { useEnvironment } from '@/contexts/useEnvironment';
import { useFeatureFlags } from '@/contexts/useFeatureFlags';
import { useUser } from '@/contexts/useUser';
import { PreferencesKey } from '@/data/dal/preferencesKey';

import { JobStepRow } from './jobStepRow';

export const StepsSummary = ({ job }: { job: BackupJob | RestoreJob }) => {
  const { isDev, isDemo } = useEnvironment();
  const { isEmployee } = useUser();
  const { displayJobSteps } = useFeatureFlags();
  const dal = useDAL();

  const { data: prefResponse } = dal.preferences.useUserPref(
    PreferencesKey.Preferences
  );

  const showDevFeatures =
    isDev || (isEmployee && !isDemo && prefResponse?.value?.isDevMode);

  // Only show if feature flag is enabled OR devMode is enabled, and job has steps
  const steps = 'steps' in job ? job.steps : undefined;
  if ((!displayJobSteps && !showDevFeatures) || !steps || steps.length === 0) {
    return null;
  }

  return (
    <MuiAccordion disableGutters defaultExpanded>
      <MuiAccordionSummary data-testid='steps-summary'>
        Steps
      </MuiAccordionSummary>
      <MuiAccordionDetails sx={{ padding: '0 24px 24px 24px' }}>
        <Box sx={{ overflowX: 'auto' }}>
          <Table size='small'>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 600 }}>Step</TableCell>
                <TableCell sx={{ fontWeight: 600 }}>Status</TableCell>
                <TableCell sx={{ fontWeight: 600 }}>Start Time</TableCell>
                <TableCell sx={{ fontWeight: 600 }}>End Time</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {steps.map((step, index) => (
                <JobStepRow key={`${step.stepName}-${index}`} step={step} />
              ))}
            </TableBody>
          </Table>
        </Box>
      </MuiAccordionDetails>
    </MuiAccordion>
  );
};
